import { ReactComponent as LogoBrackets } from '../assets/logo-icon.svg';
import { ReactComponent as LogoHorse } from '../assets/logo-horse.svg';

interface LoaderProps {
  theme?: 'owner' | 'rider';
  inline?: boolean;
}

const themeColors = {
  owner: { fill: '#E06032', stroke: '#7A211B', dot: 'bg-[#E06032]' },
  rider: { fill: '#3277E0', stroke: '#1B417A', dot: 'bg-[#3277e0]' },
};

export default function Loader({ theme = 'owner', inline = false }: LoaderProps) {
  const colors = themeColors[theme];
  return (
    <div className={inline ? 'flex items-center justify-center py-16' : 'min-h-screen flex items-center justify-center bg-white'}>
      <div className="flex flex-col items-center gap-4">
        <div
          className="relative w-[80px] h-[78px] animate-pulse"
          style={{ '--fill-0': colors.fill, '--stroke-0': colors.stroke } as React.CSSProperties}
        >
          <LogoBrackets className="absolute inset-0 w-full h-full" />
          <LogoHorse className="absolute top-[15%] left-[15%] w-[67%] h-[67%]" />
        </div>
        <div className="flex gap-1">
          <span className={`w-2 h-2 rounded-full ${colors.dot} animate-bounce`} style={{ animationDelay: '0ms' }} />
          <span className={`w-2 h-2 rounded-full ${colors.dot} animate-bounce`} style={{ animationDelay: '150ms' }} />
          <span className={`w-2 h-2 rounded-full ${colors.dot} animate-bounce`} style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </div>
  );
}
